<template>
    <div>
        <div class="card mt-2">
            <div class="card-header">Your Details</div>
            <div class="card-body">
                <div class="row">
                    <div class="col-xs-auto col-lg-6"><strong>Name:</strong> {{ clientName }}</div>
                    <div class="col-xs-auto col-lg-6"><strong>Email:</strong> {{ clientEmail }}</div>
                </div>
            </div>
        </div>

        <div class="card mt-2">
            <div class="card-header">Passenger Details</div>
            <div class="card-body">
                <div class="row justify-content-between">
                    <div v-for="(p, index) in passengers" :key="index" class="col-xs-12 col-md-6">
                        {{ p.title }} {{ p.firstName }} {{ p.lastName }}</div>
                </div>
            </div>
        </div>

        <div class="card mt-2">
            <div class="card-header">Your Trip</div>
            <div class="card-body">
                <div class="row">
                    <div class="col-xs-auto col-lg-6"><strong>Arriving:</strong> {{ fromDateString }}</div>
                    <div v-if="inboundAirport != null"
                        class="col-xs-auto col-lg-6"><strong>Airport:</strong> {{ inboundAirport.name }}</div>
                    
                    <div class="col-xs-auto col-lg-6"><strong>Departing:</strong> {{ toDateString }}</div>
                    <div v-if="outboundAirport != null"
                        class="col-xs-auto col-lg-6"><strong>Airport:</strong> {{ outboundAirport.name }}</div>
                </div>
            </div>
        </div>

        <div class="card mt-2">
            <div class="card-header">Your Itinerary</div>
            <div class="card-body">
                <app-dbd-day v-for="(day, index) in days" :key="day.number" 
                    :day="day"
                    :prevDay="index > 0 ? days[index - 1] : null"
                    :nextDay="index < days.length ? days[index + 1] : null"
                    :readOnly="true">
                </app-dbd-day>
            </div>
        </div>

        <div class="card mt-2">
            <div class="card-header">
                <div v-if="calculatedPrice" class="row justify-content-between">
                    <div class="col-auto">TOTAL PRICE</div>
                    <div class="col-auto">{{ pricing.totalPriceFormatted }}</div>
                </div>
                <div v-if="calculatedPrice" class="row justify-content-between">
                    <div class="col-auto">{{ paymentLabel }}</div>
                    <div class="col-auto">{{ pricing.amountToPayFormatted }}</div>
                </div>
                <div v-if="!calculatedPrice" class="row justify-content-between">
                    <div class="col-auto">
                        <strong>Calculating price...</strong>
                        <div class="ml-5 spinner-border" role="status">
                            <span class="sr-only">Calculating price...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col">
                <div class="form-group form-inline justify-content-between mr-2">
                    <label class="form-control-label"><span>I have read and agree to the <a @click="showTerms = true" href="javascript:void(0);">terms and conditions</a></span></label>
                    <input @disabled="!termsViewed" type="checkbox" v-model="termsAgreed" class="form-control">
                </div>
            </div>
        </div>
        
        <div class="row justify-content-end my-4">
            <button class="btn btn-info mx-1" @click="prevStep">Previous</button>
            <button :disabled="!termsAgreed" class="btn btn-success" @click="nextStep">Continue and Pay</button>
        </div>

        <b-modal id="ts-and-cs-dialog" 
             size="xl" 
             scrollable 
             title="Terms and Conditions"
             ok-only
             v-model="showTerms">
            <app-ts-and-cs></app-ts-and-cs>
        </b-modal>
    </div>       
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import appDbdDay from '../day-by-day/Day.vue';
import appTsAndCs from '../TsAndCs.vue';

export default {
    data() {
        return { 
             showTerms: false,
             termsAgreed: false,
        }
    },
    computed: {
        ...mapState({
            days: state => state.dayByDay.days,
            clientName: state => state.passengers.client.title + ' ' + state.passengers.client.firstName + ' ' + 
                state.passengers.client.lastName,
            clientEmail: state => state.passengers.client.email,
            passengers: state => state.passengers.passengers,
            fromDate: state => state.start.fromDate,
            inboundAirport: state => state.transfers.inboundAirport,
            outboundAirport: state => state.transfers.outboundAirport,
            calculatedPrice: state => state.dayByDay.calculatedPricing,
            pricing: state => state.dayByDay.pricing
        }),
        ...mapGetters({ 
            toDate: 'toDate'
        }),
        dateOptions() { 
            const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
            return options;
        },
        fromDateString() {
            return this.fromDate.toLocaleString(undefined, this.dateOptions);
        },
        toDateString() {
            return this.toDate.toLocaleString(undefined, this.dateOptions);
        },
        paymentLabel() { 
            return this.pricing.amountToPay < this.pricing.totalPrice ? 'DEPOSIT' : 'TO PAY TODAY';
        }
    },
    methods: {
        ...mapActions([ 'prevStep', 'nextStep' ])
    },
    components: {
        appDbdDay,
        appTsAndCs,
    },
    async created() {
        await this.$store.dispatch('initCurrencies');
        this.$store.dispatch('setPricing');
    }
}
</script>